import React from 'react';
import { Callout, Intent } from "@blueprintjs/core";

// import CreatePanelProtocolPC from './SetupProtocol/PC';
import CreatePanelProtocolMS from './SetupProtocol/MS';
import CreatePanelProtocolMC from './SetupProtocol/MC';

class ProtocolPanel extends React.Component {
    render() {
        const { sessionId,
            protocol,
            mcCriterias,
            msCriterias,
            onChangeCriteria_MC,
            onChangeCriteriaName,
            onChangeCriteria_MS,
            instances,
            attributes,
            handleChangeAttributeUnitValue,
            handleChangeAttribute,
            handleDeleteAttribute
        } = this.props;

        switch (protocol) {
            // case 'PC':
            //     return (<CreatePanelProtocolPC />);
            case 'MC':
                return (<CreatePanelProtocolMC
                    sessionId={sessionId}
                    criterias={mcCriterias}
                    onChangeCriterias={onChangeCriteria_MC}
                    instances={instances}
                    attributes={attributes}
                    onChangeCriteriaName={onChangeCriteriaName}
                    handleChangeAttributeUnitValue={handleChangeAttributeUnitValue}
                    handleChangeAttribute={handleChangeAttribute}
                    handleDeleteAttribute={handleDeleteAttribute}
                />);
            case 'MS':
                return (<CreatePanelProtocolMS criterias={msCriterias} onChangeCriterias={onChangeCriteria_MS} instances={instances} />);
            default:
                return (<Callout intent={Intent.PRIMARY} title="Vous y êtes presque">Choisissez un protocol de vote pour commencer à le configurer</Callout>)
        }
    }
}

export default ProtocolPanel;
